import React, { useState } from "react";
import { Tab } from "react-bootstrap";
import GeopoliticalZones from "./GeopoliticalZones";
import States from "./States";

const TABS = [
  { key: "zones", label: "Geopolitical Zones" },
  { key: "states", label: "States" },
];

export default function ZonesSection() {
  const [activeKey, setActiveKey] = useState("zones");
  const [selectedZone, setSelectedZone] = useState("All States");

  const handleViewStates = (zoneName) => {
    setSelectedZone(zoneName);
    setActiveKey("states");
  };

  return (
    <div className="px-4 md:px-6 py-2 pb-5">
      {/* Tab toggle */}
      <div
        className="flex mb-5 p-1 md:max-w-md w-full bg-white"
        style={{
          width: "fit-content",
          border: "1px solid #292C2A33",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        {TABS.map((tab) => {
          const isActive = activeKey === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveKey(tab.key)}
              className="zone-tab-btn px-6 py-2 text-sm font-medium"
              style={{
                background: isActive ? "#006B3F" : "#fff",
                color: isActive ? "#fff" : "#292C2A",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
                transition: "background 0.2s, color 0.2s",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      {/* react-bootstrap Tab manages show/hide of panes */}
      <Tab.Container activeKey={activeKey}>
        <Tab.Content>
          <Tab.Pane eventKey="zones" mountOnEnter>
            <GeopoliticalZones onViewStates={handleViewStates} />
          </Tab.Pane>
          <Tab.Pane eventKey="states" mountOnEnter>
            <States initialZone={selectedZone} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
